import { TieredMenu } from "primereact/tieredmenu";
import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import styles from "./index.module.scss";

export default function Index({ popRef }: any) {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialSortBy = searchParams.get("sortBy") || "last_call_date";
  const [selectedSortMenuItem, setSelectedSortMenuItem] = useState(initialSortBy);

  React.useEffect(() => {
    const handleScroll = () => {
      const inst: any = popRef?.current;
      if (!inst) return;
      try {
        const el = typeof inst.getElement === "function" ? inst.getElement() : inst?.container || inst?.overlay || null;
        if (!el) return;
        if (typeof inst.hide === "function") inst.hide();
      } catch (_) {}
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, [popRef]);

  const handleMenuItemClick = (id: string, commandFn: () => void) => {
    setSelectedSortMenuItem(id);
    const updatedParams = new URLSearchParams(searchParams);
    updatedParams.set("sortBy", id);
    setSearchParams(updatedParams);
    commandFn?.(); // Execute the original sort command logic
  };

  const sortItems = [
    {
      label: <span id="last_call_date">Last Call Date (Recent → Old)</span>,
      command: () => {
        console.log("Sorting by Last Call Date");
        // Your sorting logic here
      }
    },
    {
      label: <span id="investor_name">Investor Name (A–Z)</span>,
      command: () => {
        console.log("Sorting by Investor Name");
        // Your sorting logic here
      }
    },
    {
      label: <span id="property_price">Property Price (High → Low)</span>,
      command: () => {
        console.log("Sorting by Property Price");
        // Your sorting logic here
      }
    },
    {
      label: (
        <span id="status_priority">Status Priority → Interested at top</span>
      ),
      command: () => {
        console.log("Sorting by Status Priority");
        // Your sorting logic here
      }
    }
  ];

  const sortMenuItems = sortItems.map((item: any) => ({
    ...item,
    className:
      selectedSortMenuItem === item.label.props.id ? styles.selected : "",
    command: () => handleMenuItemClick(item.label.props.id, item.command)
  }));

  return (
    <TieredMenu
      className={styles.sortMenu}
      model={sortMenuItems}
      popup
      ref={popRef}
    />
  );
}
